module.exports = __webpack_public_path__ + "img/pr1.fb67e6c1.png";